<template>
  <div id="assessment-top" v-if="userHasAppPermission('view-assessment')">
    <div v-if="application_status.loaded">
        <md-tabs
          class="md-secondary section-tabs"
          md-alignment="centered"
        >
          <md-tab id="ram" md-label="RAM" md-dynamic-height>
            <!-- RAM Assessment Status -->
            <assessment-status-view
              v-if="!isRAMError"
              @setRamError="setRamError"
              v-model="ml_assessment"
              refreshable
            />
            <failed-ram-assessment-view
              v-else
              @setRamError="setRamError"
              @fetchMlAssessment="fetchMlAssessment"
              :assetType="application.loan.asset.type"
              refreshable
            />

            <!-- RAM Options -->
            <assessment-product-table-view
              v-model="ml_assessment"
              @select="selectProductForSubmission"
              :assessment-type="'ram'"
              :loanType="application.loan.type"
            />
          </md-tab>
        <!--   <md-tab id="ba" md-label="BA" md-dynamic-height >

            <assessment-status-view v-model="assessment" :zink-capacity-card="zinkCapacity" refreshable />

            <assessment-product-table-view
              v-model="assessment"
              :assessment-type="'adp'"
              :zink-capacity-status="zinkCapacity.card.status"
              :isOneScoreDataExist="isOneScoreDataExist"
              @select="selectProductForSubmission" />
          </md-tab> !-->
        </md-tabs>

      <!-- Assessment Survey -->
      <!-- <div class="md-layout-item md-size-100">
        <group-card title="Survey" icon="question_answer" :disabled="!enable_card.survey">


        </group-card>
      </div> -->

      <!-- Asset -->
      <edit-loan-asset v-model="application" />

      <!-- Suitability Assessment -->
      <edit-suitability-assessment v-if="!application.loan.is_commercial" v-model="application" @completed="suitabilityAssessmentCompleted"/>

      <!-- Insurance -->
      <edit-loan-insurances v-model="application" />

      <!-- Current Submission -->
      <edit-loan-current-submission v-model="application" :zink-capacity="zinkCapacity" :suitability-assessment="suitabilityAssessment" v-if="toggleSubmitToLenderForm"/>

      <!-- Previous Submissions -->
      <edit-loan-previous-submissions v-model="application" :suitability-assessment="suitabilityAssessment"/>
      <floating-comment-section v-model="application" :available-sections="availableSections" :current-sections="currentSections" />
    </div>

    <div v-else-if="application_status.loading">
      <md-empty-state
        md-icon="hourglass_empty"
        md-label="Loading"
        md-description="Please wait whilst the application is loading"
      />
    </div>

    <div v-else>
      <md-empty-state
        md-icon="close"
        md-label="No Application selected"
        md-description="Go to the Dashboard and select an application."
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GroupCard } from "@/components";
import Editors from "@/components/Editors";
import AssessmentStatusView from "@/components/Assessment/AssessmentStatusView";
import AssessmentProductTableView from "@/components/Assessment/AssessmentProductTableView";
import FailedRamAssessmentView from "../components/Assessment/FailedRamAssessmentView.vue";
import FloatingCommentSection from '@/components/Editors/FloatingCommentSection';
import { hasSpouse, uncommittedIncomeValidation } from "@/components/utils/validation";

import filters from "@/components/utils/filters";
import VueScrollTo from "vue-scrollto";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";

export default {
  components: {
    GroupCard,
    AssessmentStatusView,
    AssessmentProductTableView,
    FailedRamAssessmentView,
    FloatingCommentSection,
    ...Editors,
  },
  data() {
    return {
      availableSections: [
        'Assess & Submit',
        'Wallet Notification'
      ],
      currentSections: 'Assess & Submit',
      isOneScoreDataExist: false,
      isRAMError: false,
      suitabilityAssessment: false
    }
  },
  computed: {
    ...mapGetters([
      "assessment",
      "ml_assessment",
      "application",
      "application_status",
      "security",
      "toggleSubmitToLenderForm",
      "userHasAppPermission",
      "is_ram_authorized",
      "userHasRole",
      "get_preliminary_assessment_documents"
    ]),
    zinkCapacity () {
      const { status, description, buttonDisabled } = this.livingExpenseValidation();
      return {
        card: {
          title: 'Zink Capacity Rules',
          status,
        },
        note: {
          status,
          description,
        },
        disabled: buttonDisabled,
        warnings: description
      }
    },
  },
  methods: {
    async getIsRamAllowed() {
      try {
        // Check if user is authorised
        await axios.get('/api/v1/user/authorize-assessment');
        this.$store.commit('set_is_ram_authorized', true);
      } catch (error) {
        console.error('Error hitting the Assesment Authorization endpoint:', error);
        this.$store.commit('set_is_ram_authorized', false);
      }
    },
    selectProductForSubmission(item, type) {
      const product_name = type === 'ram' ? item.product_grade_name : item.product_name;
      this.application.loan.submission.current.product = {
        id: null,
        lender_name: item.lender_name,
        product_name: product_name,
        product_type: "loan",
        asset_type: "vehicle",
        application_type: "consumer",
      };

      this.application.loan.submission.current.rate = this.round(item.rate_max, 2);
      this.application.loan.submission.current.document_origination_fee = this.round(item.broker_fee, 2);
      this.application.loan.submission.current.naf = Math.min(
        item.amount_max,
        this.security['requested_amount']
      );
      this.application.loan.submission.current.term = Math.min(
        item.term_max,
        this.application.loan.requested.term
      );
      this.application.loan.submission.current.payment_frequency = "Monthly";

      // Create Peliminary Submission
      //this.generatePreliminaryDocument();
    },
    async generatePreliminaryDocument() {
        try {
            await this.$store.dispatch("generate_preliminary_documents", this.application);
            this.premliminaryAssessmentError = false;
        } catch(error) {
            console.error(error);
            this.premliminaryAssessmentError = true;
        }
    },
    livingExpenseValidation () {
      if (this.application) {
        const unCommittedIncomes = uncommittedIncomeValidation(this.application);
        if (unCommittedIncomes.zinkUncommittedIncome < 200) {
          return {
            status: 'bad',
            description: 'No Capacity Evident',
            buttonDisabled: true,
          }
        } else {
          if (unCommittedIncomes.minimumUncommittedIncome < 200 && unCommittedIncomes.hemUncommittedIncome < 200) {
            return {
              status: 'bad',
              description: 'No Capacity Evident',
              buttonDisabled: true,
            }
          } else if (unCommittedIncomes.minimumUncommittedIncome < 200 || unCommittedIncomes.hemUncommittedIncome < 200) {
            return {
              status: 'neutral',
              description: 'Limited Capacity Evident, Confirm Lender Capacity before submission',
              buttonDisabled: false,
            }
          }
        }
      }

      return {
        status: 'good',
        description: 'Accept',
        buttonDisabled: false,
      }
    },
    async fetchMlAssessment() {
      try {
        await this.$store.dispatch("fetch_ml_assessment");
        this.isRAMError = false;
        if (this.$modal.submit) {
          this.$modal.submit();
        }
      } catch(error) {
        console.error(error);
        this.isRAMError = true;
      }
      // Fetch / generate System Preliminary Assessment
      await this.generatePreliminaryDocument();
    },
    oneScoreData() {
      try {
        if (this.application['applicants']['0']['veda_report']['credit_score']['v_10']) {
          this.isOneScoreDataExist = true;
        }
      } catch (error) {
        console.error('Existence of One Score Data', error);
      }
    },
    setRamError(isError=false) {
      this.isRAMError = isError
    },
    suitabilityAssessmentCompleted(passed) {
        this.suitabilityAssessment = passed;
    },
    ...filters,
  },

  filters: {
    ...filters,
  },
  mounted() {
    if (this.userHasAppPermission("view-assessment")) {
      this.oneScoreData();
    }

    this.getIsRamAllowed().then(() => {
      if (this.is_ram_authorized) {
        this.fetchMlAssessment();
      }
    });

    //scroll to the top when the element is mounted
    this.$scrollTo('#assessment-top', {container: ".scroll-area"})
  },
};

</script>

<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
</style>
